import { createFileRoute } from '@tanstack/react-router';
import { SavedMatrixScreen } from '@/features/allergens/SavedMatrixScreen';
import { parseCellPick, type SavedSearch } from '@/features/allergens/lib/search';

/** A saved matrix. ?cell=<recipe id>-<allergen id> opens that cell's
 *  override dialog on arrival: the live matrix sends it when a chef taps a
 *  cell there and saves a copy to set it by hand. */
export const Route = createFileRoute('/_app/allergens/saved/$id')({
  validateSearch: (s: Record<string, unknown>): SavedSearch => ({ cell: parseCellPick(s.cell) }),
  component: SavedMatrixRoute,
});

function SavedMatrixRoute() {
  const { id } = Route.useParams();
  const { cell } = Route.useSearch();
  return <SavedMatrixScreen id={Number(id)} startCell={cell} />;
}
